export default {
  namespaced: true,
  state: {
    data: null
  },
  mutations: {
    setData(state, payload) {
      state.data = payload
    },
    clearData(state) {
      state.data = null
    }
  },
  getters: {
    getData: (state) => state.data
  }
}
/*save - this.$store.commit('temp/setData', this.inputs)
computed:
    tempRegData() {
      return this.$store.getters['temp/getData'] ?? null
    }
clear - this.$store.commit('temp/clearData')
 */
